import { Image } from '../../wordpress/components'
import { componentSelector } from '../../wordpress/selectors'

import '../styles/WhyChoose.scss'

export const whyChooseConfigurationSelector = componentSelector('features')

const Feature = ({ feature }) => (
    <div className="col-xs-12 col-sm-6 col-md-3 feature">
        <div className="img-container">
            <Image image={feature.icon} alt={feature.icon.alt} />
        </div>
        <br />
        <div className="header-container">
            <h3 className="font-weight-bold">{feature.title}</h3>
        </div>
        <div className="text text-large">{feature.text}</div>
    </div>
)

const WhyChooseElements = ({ features = [] }) => (
    <div className="row">
        {features.map((feature, index) => (
            <Feature key={index} feature={feature} />
        ))}
    </div>
)

export const WhyChoose = props => (
    <div className="why-choose">
        <div className="container">
            <h1>{props.title}</h1>
            <div>
                <WhyChooseElements {...props} />
            </div>
        </div>
    </div>
)

export default connect(whyChooseConfigurationSelector)(WhyChoose)
